<template>
    <!-- 员工管理 -->
    <div class="main-container">
        <div class="content">
            <div class="search-box">
                <div class="input-item">
                    <span class="label">考核时间</span>
                    <DatePicker transfer format="yyyy-MM" type="month" v-model="searchParams.accountDate" clearable
                        placeholder="请选择">
                    </DatePicker>
                </div>
                <div class="input-item">
                    <span class="label">所属组织</span>
                    <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
                </div>
                <div class="input-item">
                    <span class="label">基本法</span>
                    <Select v-model="searchParams.baseId" placeholder="请选择" transfer filterable>
                        <Option v-for="(item, i) in baseList" :value="item.id" :key="i">{{ item.name }}</Option>
                    </Select>
                </div>
                <div class="input-item" v-if="userInfo.userType != 4">
                    <span class="label">业务员</span>
                    <Select clearable v-model="searchParams.staffNo" style="width:256px;" filterable :transfer="true">
                        <Option v-for="(item, i) in salesmanList" :key="i" :value="item.staffNo" :label="item.name">
                            <span class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></span>
                            {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
                        </Option>
                    </Select>
                </div>
                <div class="input-item">
                    <span class="label">考核职级</span>
                    <Select v-model="searchParams.rankId" transfer filterable @on-change="getColumns(); searchAjax()">
                        <Option v-for="(item, i) in rankList" :key="i" :value="item.id">{{ item.name }}</Option>
                    </Select>
                </div>
                <div class="input-item">
                    <span class="label">考核结论</span>
                    <Select v-model="searchParams.isSuccess" clearable transfer filterable>
                        <Option value="999">全部</Option>
                        <Option value="1">通过</Option>
                        <Option value="0">不通过</Option>
                    </Select>
                </div>
                <div class="btn-item">
                    <Button type="primary" @click="searchAjax()">查询</Button>
                    <Button class="reset-btn" @click="resetSearch(); getColumns();">重置</Button>
                    <Button type="primary" @click="calc">
                        计算考核结果
                    </Button>
                </div>
            </div>
            <div class="tab-wrap">
                <span :class="{ tab: true, active: checkType == '1' }" @click="selTab('1')">正常考核</span>
                <span v-if="userInfo.merchantNo != 'XINHONG001' && userInfo.merchantNo != '203258000000800'" :class="{ tab: true, active: checkType == '2' }" @click="selTab('2')">不考核</span>
            </div>
            <div class="table-box setTable">
                <loading :isShow="listLoading" />
                <Table :columns="columns" :data="tableData">
                    <template slot-scope="{ row }" slot="accountDate">
                        <span>{{ row.accountDate | filterTime('YYYY/MM') }}</span>
                    </template>
                    <template slot-scope="{ row }" slot="rankName">
                        <span> {{ row.rankName }}/{{ row.newRankName }}</span>
                    </template>
                    <template slot-scope="{ row }" slot="userName">
                        <span>
                            <span class="dian" :class="{ 'red': row.workingState == 0, 'orange': row.isSus == 1 }"></span>
                            {{ row.staffNo }}/{{ row.userName }}</span>
                    </template>
                    <template slot-scope="{ row }" slot="organizationName">
                        <span class="dian" :class="row.orgStatus == 1 ? '' : 'red'"></span> <span>{{ row.organizationName
                        }}/{{
    row.groupName }}</span>
                    </template>
                    <template slot-scope="{ row }" slot="action">
                        <span class="table-btn" @click="goDetail(row)">指标详情</span>
                    </template>
                </Table>
                <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
                    style="text-align: center" />
            </div>
        </div>
        <riseModal ref="riseModal" @success="getList()"></riseModal>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapState } from "vuex";
import { pageTool } from '@/api/mixins';
import { config } from './riseRank.config.js';
import riseModal from './components/riseModal';
import selectTree from '@/components/system/selectTree3';
export default {
    mixins: [pageTool, config],
    components: {
        selectTree,
        riseModal,
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    props: {},
    data() {
        return {
            salesmanList: [],//所属业务员
            searchParams: {
                type: 1,
                isSuccess: '999',
                rankId: '',
                staffNo: '',
                applyOrgId: ''
            },
            checkType: '1',//1-正常考核 2-不考核
            rankList: [], //职级考核
            baseList: [],//基本法列表
        };
    },
    created() { },
    mounted() {
        this.init()
    },
    methods: {
        // 重置查询
        resetSearch() {
            this.searchParams = JSON.parse(JSON.stringify(this.searchParamsOrigin));
            this.getOrganizationUser(null)
            this.searchAjax();
        },
        async init() {
            await this.getRankList();
            await this.getBaseList();
            this.getOrganizationUser(null)
            this.initListAjax('/buz/userPromotionRecord/page');
            this.getColumns();
        },
        calc() {
            let rankName = this.rankList.find(i => i.id == this.searchParams.rankId).name
            let baseName = this.baseList.find(i => i.id == this.searchParams.baseId).name
            let params = JSON.parse(JSON.stringify(this.searchParams));
            this.setListParams(params);
            params.pageSize = '999';
            params.pageNo = '1';
            this.$emit('open', { type: '1', rankId: this.searchParams.rankId, rankName, baseName, baseId: this.searchParams.baseId, accountDate: this.searchParams.accountDate }, params)
        },
        // 获取基本法数据
        getBaseList() {
            return new Promise((resolve, reject) => {
                this.$http({
                    type: "GET",
                    url: "/buz/baseMethod/queryByMechan",
                    data: {}
                }).then(res => {
                    this.baseList = res.data;
                    if (res.data && res.data.length) {
                        this.searchParams.baseId = res.data[0].id
                    }
                    resolve('')
                })
            })
        },
        selTab(val) {
            if (val == '1' && this.checkType != val) {
                this.searchParams.isSuccess = '999'
            } else if (val == '2') {
                this.searchParams.isSuccess = ''
            }
            this.checkType = val;
            this.getColumns();
            this.searchAjax();
        },
        // 通过机构获取业务员
        getOrganizationUser(id) {
            this.$http({
                url: `/buz/userBase/getByOrgIds`,
                type: "POST",
                data: {
                    orgaList: id ? [id] : []
                }
            }).then((res) => {
                this.salesmanList = res.data;
            })
        },
        // 通过机构获取业务员
        getGroupUser(id) {
            this.$http({
                url: `/buz/userBase/getByGroup?groupId=${id}`,
                type: "GET",
            }).then((res) => {
                this.salesmanList = res.data;
            })
        },
        setListParams(params) {
            if (params.accountDate) params.accountDate = dayjs(params.accountDate).format('YYYY-MM');
            if (this.checkType) {
                params.checkType = this.checkType;
            }
            if (params.isSuccess == '999') {
                params.isSuccess = '';
            }
        },
        goDetail(row) {
            this.$router.push({
                path: '/orderManage/testManagement/riseDetail',
                query: {
                    id: row.id,
                    staffNo: row.staffNo,
                    userName: row.userName,
                    accountDate: row.accountDate,
                    userId: row.userId,
                    oldRankId: row.oldRankId,
                    newRankId: row.newRankId,

                }
            });
        },
        // 职级考核列表
        getRankList() {
            return new Promise((resolve, reject) => {
                this.$http({
                    url: '/buz/baseRank/read/all',
                    type: 'post',
                    data: {}
                }).then(res => {
                    if (res.data && res.data.length) {
                        this.searchParams.rankId = res.data[0].id
                    }
                    this.rankList = res.data;
                    resolve('')
                });
            });
        },
        // 组织选择
        selectTreeChange(data) {
            console.log(data)
            this.searchParams.staffNo = '';
            if (data.nodeType == 1) {
                //机构
                this.searchParams.organizationId = data.id;
                this.searchParams.groupId = '';
                this.getOrganizationUser(data.id)
            } else if (data.nodeType == 2) {
                //团队
                this.searchParams.organizationId = '';
                this.getGroupUser(data.id)
                this.searchParams.groupId = data.id;
            } else {
                this.searchParams.organizationId = '';
                this.searchParams.groupId = '';
                this.salesmanList = [];
                this.getOrganizationUser(null)
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.btn-top-wrap {
    margin-bottom: 10px;
}

.tab-wrap {
    padding-bottom: 15px;

    .tab {
        cursor: pointer;
        margin-left: 20px;
        width: 70px;
        display: inline-block;
        text-align: center;
        height: 26px;
        line-height: 26px;
        border-radius: 2px;
        color: #727c8e;
        background-color: #f7f8fa;

        &:first-child {
            margin-left: 0;
        }
    }

    .active {
        background-color: #236dff;
        color: #fff;
    }
}

.dian {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #35bf3f;
    border-radius: 50%;
    margin-right: 4px;
    vertical-align: top;
    transform: translateY(7px);

    &.red {
        background: #e3461f;
    }
}

.table-box {

    .close,
    .opening {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 4px;
    }


    .close {
        background: #E36767;
    }

    .opening {
        background: #35BF3F;
    }

}

.main-container {
    border-left: 0;
    border-bottom: 0;
    padding: 0 0px 15px;
}

.wrapper {
    padding-top: 30px;
}

.wrapper .content {
    .search-box {
        .label {
            min-width: 80px;
        }
    }
}

.tableBox {
    .disabled {
        color: #999;
        cursor: default;
    }
}

.descLine {
    span {
        margin-right: 30px;
    }
}

/deep/ .ivu-modal-body {
    padding: 16px 30px;
}

.search-box {
    padding-right: 360px;
}
</style>
